import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOverwhelmedEmojiSecondary from './svgs/OverwhelmedEmojiSecondary.js';
import SvgOverwhelmedEmoji from './svgs/OverwhelmedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var overwhelmedEmoji = (props => useIcon(SvgOverwhelmedEmoji, SvgOverwhelmedEmojiSecondary, props));

export { overwhelmedEmoji as default };
